import { render, staticRenderFns } from "./AddLabels.vue?vue&type=template&id=26ceee7c&scoped=true"
import script from "./AddLabels.vue?vue&type=script&lang=ts"
export * from "./AddLabels.vue?vue&type=script&lang=ts"
import style0 from "./AddLabels.vue?vue&type=style&index=0&id=26ceee7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ceee7c",
  null
  
)

export default component.exports